import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
  bankTab: 'AXIS',
  open: false,
  caDetails: {},
  partyList: [],
  isLoading: true,
  gstData: [],
};

const slice = createSlice({
  name: 'capanel',
  initialState,
  reducers: {
    setOpen(state, action) {
      state.open = action.payload;
    },
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setCaDetails(state, action) {
      state.caDetails = action.payload;
    },
    setPartyList(state, action) {
      state.partyList = action.payload;
    },
    setGstData(state, action) {
      state.gstData = action.payload;
    },
  },
});

export default slice.reducer;

export const { setOpen, setCaDetails, setPartyList, setIsLoading, setGstData } = slice.actions;

export const getGstDetails = (rt, fy, p) => async (dispatch) => {
  try {
    await axios.get(`/CaPanel/get_gstDetails?return_type=${rt}&fy=${fy}&ret_period=${p}`).then((response) => {
      dispatch(setGstData(response.data));
      dispatch(setIsLoading(false));
    });
  } catch (error) {
    return console.error(error.message);
  }
  return true;
};

export const getPartyList = () => async (dispatch) => {
  try {
    await axios.get(`/CaPanel/get_firmDetails`).then((response) => {
      dispatch(setPartyList(response.data));
      dispatch(setIsLoading(false));
    });
  } catch (error) {
    dispatch(setIsLoading(false));
    return console.error(error.message);
  }
  return true;
};

export const getCaDeatails = () => async (dispatch) => {
  try {
    await axios.get(`/CaPanel/get_caDetails`).then((response) => dispatch(setCaDetails(response.data[0])));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    return console.error(error.message);
  }
  return true;
};

// export const getBankTransaction = (a) => async (dispatch) => {
//   try {
//     await axios.get(`/get_Banktransaction?bank_Name=${a}`).then((response) => dispatch(setBankTransaction(response.data?.data
//     )));
//   } catch (error) {
//     return console.error(error.message);
//   }
//   return true;
// };
